import { Controller } from "@hotwired/stimulus"
import { Autocomplete } from "stimulus-autocomplete"
import { useClickOutside } from 'stimulus-use'

// Connects to data-controller="autocompleteclickout"
export default class extends Autocomplete {
  connect() {
    super.connect();
    useClickOutside(this)
  }

  clickOutside(event) {
    if (this.hiddenTarget.value == null || this.hiddenTarget.value == '' || this.hiddenTarget.value == undefined) {
      this.inputTarget.value = '';
    }
  }
}